export default __webpack_public_path__ + "static/media/laptop.aee0f771.png";